import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, OutlinedInput, useTheme } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';

type SizeSearch = 'medium' | 'small';

export interface Props extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  clearButtonOnClick?: () => void;
  id?: string;
  sizeSearch?: SizeSearch;
}

const Search = React.forwardRef<HTMLInputElement | null, Props>((props) => {
  const theme = useTheme();
  const { translation } = useTranslation();
  const { onChange, value, clearButtonOnClick, id = 'search-input', style, sizeSearch = 'small' } = props;

  return (
    <OutlinedInput
      fullWidth
      id={id}
      onChange={onChange}
      value={value}
      size={sizeSearch}
      placeholder={translation.search}
      error={false}
      notched={false}
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon sx={{ fill: value !== '' ? theme.palette.text.primary : theme.palette.text.secondary }} />
        </InputAdornment>
      }
      endAdornment={
        value !== '' && clearButtonOnClick !== undefined ? (
          <InputAdornment position="end">
            <IconButton onClick={clearButtonOnClick} aria-label="clear">
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ) : undefined
      }
      style={style}
    />
  );
});

export default Search;
